module.exports = require("core-js/library/fn/reflect/get");